'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var FormRow = function FormRow(props) {
    var className = (0, _classnames2['default'])('FormRow', props.className);
    var rest = (0, _blacklist2['default'])(props, 'className');
    return _react2['default'].createElement('div', _extends({}, rest, { className: className }));
};

FormRow.propTypes = {
    className: _propTypes2['default'].string
};

module.exports = FormRow;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/FormRow.js
// module id = 968
// module chunks = 0 1